import { EmailLoginCommand } from "commands/account/EmailLoginCommand";
import { GlobalDataResult } from "results/account/GlobalDataResult";
import { useApiService } from "services/ApiService";
import { SchoolLoginResult } from "results/account/SchoolLoginResult";

export const AccountApiService = () => {
    const { get, post } = useApiService({ controller: "/account" });

    return {
        login: (command: EmailLoginCommand) => post<SchoolLoginResult>("/login", command),
        getGlobalUserData: () => get<GlobalDataResult>("/global-data"),
    };
};
